import { render, staticRenderFns } from "./ApiItemNew.vue?vue&type=template&id=019c8a06"
import script from "./ApiItemNew.vue?vue&type=script&lang=js"
export * from "./ApiItemNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports